import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { Observable } from 'rxjs';
import { filter, first, mergeMap } from 'rxjs/operators';

/** Add JWT Authorization header to request. */
@Injectable()
export class AddJwtHeaderInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // File uploads are handed directly to S3 and should NOT add the jwt header
    // CXA calls also do not need jw on header
    if (req.body instanceof File) {
      return next.handle(req);
    } else if (req.url.includes('/tce-consumer-experience-api')) {
      // Clone the request to add the Accept-Language header
      const modifiedReq = req.clone({
        headers: req.headers.set('Accept-Language', ''),
      });
      return next.handle(modifiedReq);
    } else {
      // Get the JWT token from AuthService
      const activeTenantIdentifier = localStorage.getItem('active_tenant_identifier');
      return this.authService
        .getAccessTokenSilently({
          authorizationParams: {
            active_Tenant_Identifier: activeTenantIdentifier,
          },
        })
        .pipe(
          filter((data) => {
            // initial value is undefined so filter that out
            return data ? true : false;
          }),
          first(),
          mergeMap((jwt) => {
            const jwtRequest = this.setJwtHeaders(req, jwt);
            return next.handle(jwtRequest);
          }),
        );
    }
  }

  private setJwtHeaders(req: HttpRequest<any>, jwt: string): HttpRequest<any> {
    localStorage.setItem('bearer', jwt);
    let request: HttpRequest<any>;
    request = req.clone({
      headers: req.headers
        .set('content-type', 'application/json; charset=utf-8')
        .set('Accept', '*/*')
        .set('Authorization', 'Bearer ' + jwt),
    });

    if (req.url.includes('/stores/export') || req.url.includes('/reports/interactions/export')) {
      request = req.clone({
        headers: req.headers
          .set('content-type', 'application/json; charset=utf-8')
          .set('Accept', 'text/csv')
          .set('Authorization', 'Bearer ' + jwt),
      });
    }
    return request;
  }
}
